class BundleProduct extends HTMLElement{
    constructor() {
        super();
        this.totalPrice = 0;
        this.comparePrice = 0;
        this.productCounter = 0;
        this.productBundle = {
            items: [],
            sections: ["cart-drawer", "cart-icon-bubble"],
            section_url: `${window.location.pathname}`,
        };
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.bundleAtc = this.querySelector('#product-bundle-button');
        this.inputElements = document.querySelectorAll('input.product__bundle__check, borosil-xs-card select.select__select');
        this.attachEventListeners();
        this.bundleAtc.addEventListener('click', () => this.addProductsToCart());

        // Observe changes in the DOM to reattach event listeners
        const observer = new MutationObserver(() => this.attachEventListeners());
        observer.observe(this, { childList: true, subtree: true });
    }

    attachEventListeners() {
        this.inputElements = document.querySelectorAll('input.product__bundle__check, borosil-xs-card select.select__select');
        this.inputElements.forEach(input => {
            if (!input.dataset.listenerAttached) {
                input.addEventListener("change", (e) => this.bundleProducts(e));
                input.dataset.listenerAttached = true; // Mark as attached
            }
        });
    }

    bundleProducts(event) {
        const isSelectSelect = event.target.classList.contains('select__select');
        
        if (isSelectSelect) {
            // Reset everything if the event is triggered by a select__select element
            this.resetBundle();
        } else {
            event.target.classList.toggle('checked');
            const isChecked = event.target.checked;
            const productPrice = formatPrice(event.target.dataset.productPrice);
            const productComparePrice = formatPrice(event.target.dataset.comparePrice);
            const variantId = parseInt(event.target.dataset.variantId);

            if (isChecked == undefined) {
                this.resetBundle();
            } else if (isChecked) {
                // Adding the product
                this.totalPrice += parseInt(productPrice);
                this.comparePrice += parseInt(productComparePrice);
                this.productCounter++;
                this.productBundle.items.push({
                    id: variantId,
                    quantity: 1
                });
            } else {
                // Removing the product
                if (this.totalPrice === 0) return;
                this.totalPrice -= parseInt(productPrice);
                if (this.comparePrice === 0) return;
                this.comparePrice -= parseInt(productComparePrice);
                if (this.productCounter === 0) return;
                this.productCounter--;
                const index = this.productBundle.items.findIndex(item => item.id === variantId);
                if (index !== -1) {
                    this.productBundle.items.splice(index, 1);
                }
            }
        }

        // Update the UI
        document.querySelector('.product__bundle__price').textContent = `₹${formatIndianCurrency(this.totalPrice > 0 ? this.totalPrice : 0)}`;
        document.querySelector('.items__counter').textContent = `Total Amount (${this.productCounter} ${this.productCounter === 1 ? 'item' : 'items'})`;

        // Disable Add to Cart button if no items are selected
        this.bundleAtc.disabled = this.productCounter === 0;
    }

    resetBundle() {
        this.totalPrice = 0;
        this.comparePrice = 0;
        this.productCounter = 0;
        this.productBundle.items = [];
        this.inputElements.forEach(input => {
            input.classList.remove('checked');
            input.checked = false;
        });
    }

    addProductsToCart() {
        if (this.productBundle == null) return;
       
        this.submitButton = this.querySelector('#product-bundle-button');
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.productBundle),
        })
        .then(response => response.json())
        .then(data => {
            this.cart.renderContents(data);
        })
        .catch(error => {
            console.error('Error adding products to cart:', error);
        })
        .finally(() => {
            this.submitButton?.classList.remove("loading");
            if (this.cart && this.cart?.classList.contains("is-empty"))
                this.cart?.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
            document.querySelectorAll('.product__bundle__check').forEach(input => {
                if (input.checked) {
                    input.checked = false;
                }
            });
            
            document.querySelector('.product__bundle__price').textContent = '₹0';
            document.querySelector('.items__counter').textContent = 'Total Amount(0 item)';
            
            this.bundleAtc.disabled = true;
        });
    }
}


customElements.define('bundle-product', BundleProduct);

function formatPrice(priceInSmallestUnit) {
    const price = priceInSmallestUnit / 100;
    return price.toFixed(2).replace(/\.00$/, '');
}

function formatIndianCurrency(amount) {
    return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 0
    }).format(amount);
}
